import { useContext, useEffect, useState } from 'react';

import Button from './common/Button';
import VerticalAd from './common/VerticalAd';
import { SlideshowContext } from './SlideshowContainer';
import { createAndDispatchCustomEvent } from '../utils/events';
import ChevronMove from './common/ChevronMove';
import { Size } from '../types/AdProps';

// import { sessionSet, sessionGet } from '../utils/sessionStorage';

const TriviaQuiz = () => {
  const slideshowContext = useContext(SlideshowContext);
  const slideshowContent = slideshowContext?.content;

  const currentURL = new URL(window.location.href);
  const slideString = currentURL.searchParams.get('slide'); 
  const initialSlideValue = slideString ? parseInt(slideString) : null;
  const [currSlideIdx, setCurrSlideIdx] = useState<number | null>(initialSlideValue && !isNaN(initialSlideValue) ? initialSlideValue - 1 : null);

  if (!slideshowContent) {
    return <div>Loading...</div>;
  }

  const { slides, landingImageElement, landingDescription } = slideshowContent;
  const totalSlides = slides.length;
  const isLastSlide = currSlideIdx === totalSlides - 1;
  const isFirstSlide = currSlideIdx === null;

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [currSlideIdx]);

  const handleNextClicked = () => {
    if (currSlideIdx !== null) {
      const nextIdx = currSlideIdx + 1;
      setCurrSlideIdx(nextIdx);

      if (isLastSlide) {
        createAndDispatchCustomEvent('slideshowFinish');
      } else {
        createAndDispatchCustomEvent('slideshowNextClicked');
      }

      const url = new URL(window.location.href);
      const slug = url.pathname.split('/')[1];

      const linkNumber = currSlideIdx + 2;
      url.searchParams.set('slide', linkNumber.toString());
      const linkToUse = `${url.origin}/${slug}/${linkNumber}?${url.searchParams.toString()}`;

      window.history.pushState({}, '', linkToUse);
    }
  };

  const handleBeginClicked = () => {
    createAndDispatchCustomEvent('slideshowBegin');
    setCurrSlideIdx(0);

    const url = new URL(window.location.href);
    const slug = url.pathname.split('/')[1];
    url.searchParams.set('slide', '1');
    const linkToUse = `${url.origin}/${slug}/1?${url.searchParams.toString()}`;
    window.history.pushState({}, '', linkToUse);
  };

  const handleNextSlideshowClicked = () => {
    createAndDispatchCustomEvent('nextSlideshowRequested');
  }

  const nextSlideButton = (handler: () => void, className: string, text?: string) => {
    return <Button
      id="quiz-next-button"
      className={`w-full flex items-center justify-center space-x-3 mb-4 slideshow-navigation-button js-next flex flex-grow py-6 px-4 bg-primary-color justify-center items-center rounded ${className}`}
      style={{ height: '85x' }}
      onClick={handler}
    >
      <div>
        <div>
          <span id="next-button-text" className="font-info uppercase font-semibold text-3xl mr-4 text-white next-button-text">{ text ?? 'Next'}</span>
        </div>
      </div>
      <ChevronMove isAnimating={true} />
    </Button>
  }

  const url = new URL(window.location.href);
  const showExtraAds = url.searchParams.get('utm_source')?.includes('_ads');

  const slideTitle = isFirstSlide ?  slideshowContent.title : slides[currSlideIdx].title;
  const imageElement = isFirstSlide ? landingImageElement : slides[currSlideIdx].imageElement;
  const description = isFirstSlide ? landingDescription : slides[currSlideIdx].description;

  return (
    <div className={`${isLastSlide ? 'mr-4 ml-4' : ''}`}>
      {
        isLastSlide ? <>
        <div id="slide-title" className="post-meta-text w-full mb-6">
          <div className="font-header text-black-light text-4xl font-medium md:leading-10 lg:leading-12 title-text">{slideshowContent.title.trim()}</div>
          <div id="after-meta-text-label"></div>
        </div>
        { nextSlideButton(handleNextSlideshowClicked, '', 'Next') }</> : null
      }
      { (showExtraAds && !isFirstSlide) ? <VerticalAd depth={0} size={Size.MedRectangle} /> : null }
      { isLastSlide ? null : <>
      <div id="slide-title" className="post-meta-text w-full mt-6 mb-1">
        <div className="font-header text-black-light text-4xl mx-1 mr-4 ml-4 font-medium md:leading-10 lg:leading-12 title-text">{removeNumericCount(slideTitle.trim()).trim()}</div>
        <div id="after-meta-text-label"></div>
      </div>
      { isFirstSlide ? null : <VerticalAd size={Size.MobileBanner}/> }
      <div className="article-content image-container slide-meta-container mb-0">
        <div dangerouslySetInnerHTML={{__html: imageElement }} >
        </div>
      </div>
      <VerticalAd depth={1} size={Size.MedRectangle}/></> }
      <div className="slide-text-container mb-4 px-5">
        <div className="slideshow-part slideshow-desc" style={{ paddingBottom : '7px', paddingTop: '7px' }}>
          <div dangerouslySetInnerHTML={{__html: description.replace(/<br\s*[\/]?>/gi, '').trim()}} >
          </div>
        </div>
      </div>
      { !isLastSlide ? 
        <div className="my-3">
          <VerticalAd depth={2} size={Size.MedRectangle} />
        </div> : null
      }
      { isLastSlide ? 
        nextSlideButton(handleNextSlideshowClicked, 'mb-16 pb-16', 'Next') : isFirstSlide ? nextSlideButton(handleBeginClicked, 'mt-16') : <div className="px-5"> { nextSlideButton(handleNextClicked, 'mt-16') }</div> }
      { !isLastSlide ? 
        <div className="mt-5">
          <VerticalAd depth={3} size={Size.MedRectangle}/>
        </div>
        : null }
    </div>
  );
};

function removeNumericCount(title: string) {
  return capitalizeFirstLetter(title.replace(/^\#{0,1}\d{1,2}[\.)]{0,1}\s/, ''));
}

function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export default TriviaQuiz;
